import 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}
function hexToRGBA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + "," + (opacity === undefined ? 1 : opacity) + ")";
    }
    else {
        return null;
    }
}
function convertToKebabCase(text) {
    if (typeof text !== 'string')
        return text;
    return text.replace(/\s+/g, '-').toLowerCase();
}

/**
 * Simple select is using the power of our ARSelect, you can say it's an implementation of our ARSelect.
 * If you want to see what it looks like, check our playbook page
 */
var ARSimpleSelect = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-select',{staticClass:"select-wrapper",attrs:{"ar-widget-id":"ar-simple-select","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-simple-select","items":_vm.items,"defaultSelectIndex":_vm.defaultSelectIndex,"filter-placeholder":_vm.filterPlaceholder,"hideArrow":_vm.hideArrow,"enableClear":_vm.enableClear,"enableFilter":_vm.enableFilter,"dropdownWidth":_vm.dropdownWidth,"dropdownStyle":_vm.dropdownStyle,"align":_vm.align,"hasError":_vm.hasError,"disabled":_vm.disabled,"data-test-id":_vm.dataTestId,"direction":_vm.direction},on:{"select":function (item, index) { _vm.$emit('select', item, index); },"filterStringInput":function (filterString) { _vm.$emit('filterStringInput', filterString); },"clear":function($event){return _vm.$emit('clear')},"open":function($event){return _vm.$emit('open')},"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"selected-item",fn:function(selectedItemScope){return [(selectedItemScope.item)?_c('div',{style:({
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        padding: '0 14px',
      }),attrs:{"data-test-id":(_vm.dataTestId + "-" + (_vm.toKebabCase(selectedItemScope.item.name)) + "-selected-option")}},[(selectedItemScope.item.imageSrc)?_c('ar-avatar',{style:({ marginRight: '10px' }),attrs:{"image-path":selectedItemScope.item.imageSrc,"name":selectedItemScope.item.name,"size":"30px"}}):_vm._e(),_vm._v(" "),_c('ar-text',{style:({
          color: _vm.$arStyle.color.skyBlueGrey800,
          width: !!selectedItemScope.item.imageSrc ? 'calc(100% - 34px)' : '100%',
        }),attrs:{"size":"xs","text":selectedItemScope.item.name,"direction":_vm.direction}}),_vm._v(" "),(selectedItemScope.item.subTitle)?_c('ar-text',{staticClass:"u-margin-left-2",style:({
          color: _vm.$arStyle.color.skyBlueGrey600,
        }),attrs:{"size":"xs","text":selectedItemScope.item.subTitle,"direction":_vm.direction}}):_vm._e()],1):_c('div',{style:({
        display: 'flex',
        height: '100%',
        width: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0 14px',
      }),attrs:{"data-test-id":(_vm.dataTestId + "-placeholder")}},[_c('ar-text',_vm._b({attrs:{"size":"xs","text":_vm.placeholder,"direction":_vm.direction}},'ar-text',_vm.placeholderProps,false))],1)]}},{key:"clear",fn:function(clearScope){return [_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
        cursor: 'pointer',
        background: clearScope.active ? _vm.hoveredColor : null,
      })},[(clearScope.selectedItem.imageSrc)?_c('div',{style:({
          height: '30px',
          width: '0',
        })}):_vm._e(),_vm._v(" "),_c('ar-text',{style:({
          width: !!clearScope.selectedItem.imageSrc ? 'calc(100% - 34px)' : '100%',
        }),attrs:{"size":"xs","text":_vm.placeholder,"direction":_vm.direction}})],1)]}},{key:"item",fn:function(itemScope){return [_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
        cursor: 'pointer',
        background: itemScope.active || itemScope.selected ? _vm.hoveredColor : null,
      }),attrs:{"data-test-id":(_vm.dataTestId + "-" + (_vm.toKebabCase(itemScope.item.name)) + "-option")}},[(itemScope.item.imageSrc)?_c('ar-avatar',{style:({
          marginRight: '10px',
        }),attrs:{"image-path":itemScope.item.imageSrc,"name":itemScope.item.name,"color":itemScope.active || itemScope.selected ? 'white' : 'grey',"size":"30px"}}):_vm._e(),_vm._v(" "),_c('ar-text',{style:({
          color: itemScope.active || itemScope.selected ? _vm.focusedColor : _vm.$arStyle.color.blueGrey800,
          width: !!itemScope.item.imageSrc ? 'calc(100% - 34px)' : '100%',
        }),attrs:{"size":"xs","weight":itemScope.selected ? 'bold' : 'normal',"text":itemScope.item.name,"direction":_vm.direction}}),_vm._v(" "),(itemScope.item.subTitle)?_c('ar-text',{staticClass:"u-margin-left-2",style:({
          color: itemScope.active || itemScope.selected ? _vm.focusedColorSubtitle : _vm.$arStyle.color.skyBlueGrey600,
        }),attrs:{"size":"xs","weight":itemScope.selected ? 'bold' : 'normal',"text":itemScope.item.subTitle,"direction":_vm.direction}}):_vm._e()],1)]}}])},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-item"},[_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
      })},[_c('ar-text',{attrs:{"size":"xs","text":"No result","direction":_vm.direction}})],1)])],2)},
staticRenderFns: [],
  name: 'SimpleSelect',
  props: {
    arWidgetMeta: String,
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    defaultSelectIndex: {
      type: Number,
      default: -1,
    },
    placeholder: {
      type: String,
      default: 'Please select...',
    },
    placeholderProps: {
      type: Object,
      default: () => ({}),
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
    enableFilter: {
      type: Boolean,
      default: false,
    },
    dropdownWidth: {
      type: Number,
      default: null,
    },
    dropdownStyle: {
      type: Object,
      default: () => {},
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'right'].indexOf(value) !== -1,
    },
    dataTestId: {
      type: String,
      default: 'simple-select',
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },
  computed: {
    computedArWidgetMeta() {
      const text = this.items[this.defaultSelectIndex] ? this.items[this.defaultSelectIndex].name : null;
      return [
        `placeholder=${this.placeholder};`,
        `text=${text};`,
      ].join('');
    },
    hoveredColor() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple100;
      }
      return hexToRGBA(this.color, 0.1);
    },
    focusedColor() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple500;
      }
      return this.color;
    },
    focusedColorSubtitle() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple400;
      }
      return this.color;
    },
  },
  methods: {
    filterPlaceholder(selectedItem) {
      if (selectedItem) {
        return selectedItem.name;
      } else {
        return this.placeholder;
      }
    },
    toKebabCase(s) {
      return convertToKebabCase(s);
    },
  },
};

export default ARSimpleSelect;
